module.exports = __webpack_public_path__ + "img/content7.b0d91db0.png";